import React, { memo, forwardRef } from 'react';
import { useListBox } from '@react-aria/listbox';
import { useListState } from '@react-stately/list';
import { mergeProps } from '@react-aria/utils';
import { useForwardedRef } from '../../hooks';
import { Box } from '../box';
import { ListContext } from './contexts';
import { ItemInner } from './Item';
export const List = memo(forwardRef(function List(props, ref) {
    const { state, selectedKeys, selectionMode, shouldFocusOnHover, shouldSelectOnPressUp, onSelectionChange, shouldUseVirtualFocus, disabledKeys, onAction, selectionBehavior, size = 'm', items, ...rest } = props;
    const listRef = useForwardedRef(ref);
    const ownState = useListState(props);
    const finalState = props.state || ownState;
    const { listBoxProps } = useListBox(props, finalState, listRef);
    return (React.createElement(ListContext.Provider, { value: { state: finalState, size } },
        React.createElement(Box, { Component: "ul", ...mergeProps(rest, listBoxProps), flex: 1, flexDirection: "column", ref: listRef }, [...finalState.collection].map((item, index) => {
            var _a;
            return (React.createElement(ItemInner, { key: (_a = item.key) !== null && _a !== void 0 ? _a : index, item: item }));
        }))));
}));
